











































































import { computed, defineComponent } from "@vue/composition-api";
import { useStaticPages } from "@/hooks/useStaticPages";
import config from "@/config";
import { ROLES } from "@/const";
import BaseButton from "@/components/BaseButton";
import CompanyInfo from "@/components/CompanyInfo.vue";
import PageTitle from "@/components/PageTitle";
import SiteLogo from "@/components/SiteLogo";
import SocialLogin from "@/components/SocialLogin";

export default defineComponent({
  name: "LoginContainer",
  components: { CompanyInfo, BaseButton, SiteLogo, PageTitle, SocialLogin },
  props: {
    signup: { type: Boolean, default: true },
    title: { type: String },
    forceDarkTheme: { type: Boolean },
    hideLogo: { type: Boolean, default: false },
    hideLinks: { type: Boolean, default: false },
    role: { type: String, default: ROLES.MEMBER },
  },
  setup(props, { root, emit }) {
    const { pages, getPages } = useStaticPages();

    const visibleLinks = computed(() =>
      pages.value?.filter(
        page =>
          page.visible &&
          (!props.signup || !["/static/privacy-policy.html", "/static/terms-of-use.html"].includes(page.path))
      )
    );

    const showPoweredBy = computed(() => !config.featureHideScrileLink);

    const termsOfUse = computed(() => {
      return pages.value.find(p => p.path.includes("terms-of-use"));
    });
    const privacyPolicy = computed(() => {
      return pages.value.find(p => p.path.includes("privacy-policy"));
    });

    const onBecomeCreatorClick = () => {
      emit("closeModal");
      root.$router.push({ name: "becomeCreator" });
    };

    getPages();

    return {
      termsOfUse,
      privacyPolicy,
      visibleLinks,
      showPoweredBy,
      onBecomeCreatorClick,
      ROLES,
    };
  },
});
